<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <!-- <ModalIdle :is-active="isIdleModal" /> -->
    <component :is="layout">
      <router-view />
    </component>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'
import { sweetAlert } from '@core/mixins/sweetAlert'
import store from '@/store'
import { initialAbility } from '@/libs/acl/config'
import ModalIdle from './views/components/modal/ModalIdle.vue'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    ModalIdle,

    ScrollToTop,
  },
  mixins: [sweetAlert],
  data() {
    return {
      onLine: navigator.onLine,
      showBackOnline: false,
      isInactive: false,
      timeout: null,
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    isUserIdle() {
      return this.$store.state.idleVue.isIdle
    },
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn
    },
    isIdleModal() {
      return this.$store.state.idleVue.isIdle && this.$store.state.auth.isLoggedIn
    },
  },
  watch: {
    isUserIdle(newValue) {
      // if (newValue && this.isLoggedIn) {
      // if (newValue) {
      //   // this.isInactive = true
      //   this.$store.dispatch('auth/updateMessage', 'Please log in again to continue. Your current session has expired due to Inactivity.')
      //   this.onLogout()
      // }

      if (newValue && this.isLoggedIn) {
        this.$store.dispatch('auth/updateMessage', 'Please log in again to continue. Your current session has expired due to Inactivity.')
        this.$store.dispatch('auth/logout') // Uncomment this line
        this.$ability.update(initialAbility)
        this.$router.push({ name: 'auth-login' })
      }
    },
    // isIdleModal(newValue) {
    //   debugger
    //   if (newValue) {
    //     this.isInactive = true
    //   }
    // },
    onLine(v) {
      if (v) {
        this.showBackOnline = true
        this.timeout = setTimeout(() => {
          this.showBackOnline = false
        }, 1000)
      }
    },

  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    //  if (colors[i] === 'primary') {
    //     $themeColors[colors[i]] = this.$store.state.auth.institutionData.color
    //     useCssVar(`--${colors[i]}`, document.documentElement, { $primary: this.$store.state.auth.institutionData.color })
    //   } else {
    //     $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    //   }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },

  mounted() {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeMount() {
    window.addEventListener('load', this.onLoad)
    window.addEventListener('beforeunload', this.onUnload)
  },
  beforeDestroy() {
    window.removeEventListener('load', this.onLoad)
    window.removeEventListener('beforeunload', this.onUnload)
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
    clearTimeout(this.timeout)
  },
  methods: {
    onLogout() {
      // this.$store.dispatch('auth/updateSessionState', true)
      // this.$store.dispatch('auth/updateMessage', 'Please log in again to continue. Your current session has expired due to Inactivity.')
      // this.$store.dispatch('auth/logout')
      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
    updateOnlineStatus(e) {
      const { type } = e
      this.onLine = type === 'online'
      if (!this.onLine) {
        this.alertError({
          title: 'No internet connection.',
          text: 'Make sure Wi-Fi or cellular data is turned on, then try again.',
          iconHtml: '<svg data-v-cce37b34="" xmlns="http://www.w3.org/2000/svg" width="40px" height="70px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" color="#F26434" class="feather feather-wifi"><path data-v-cce37b34="" d="M5 12.55a11 11 0 0 1 14.08 0"></path><path data-v-cce37b34="" d="M1.42 9a16 16 0 0 1 21.16 0"></path><path data-v-cce37b34="" d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line data-v-cce37b34="" x1="12" y1="20" x2="12.01" y2="20"></line></svg>',
        })
      }
      if (this.onLine) {
        this.$swal.close()
      }
    },
    // onLoad() {
    //   window.sessionStorage.setItem('hasActiveSession', true)
    // },
    // onUnload() {
    //   window.sessionStorage.setItem('hasActiveSession', false)
    // localStorage.removeItem('accessToken')
    // localStorage.removeItem('refreshToken')
    // this.$store.dispatch('auth/logout')
    // },
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      enableScrollToTop,
    }
  },
}
</script>

<style>
/* .table-responsive {
  padding-bottom: 200px !important;
} */
.table-responsive {
    padding-bottom: 120px !important;
    margin-bottom: 0.5rem;
  }
  .content-body > .card {
    margin-bottom: 0rem !important;
  }
.content.app-content {
    padding: calc(1rem + 4.45rem + 1.3rem) 2rem 0 !important;
}

.table th, .table td {
    /* padding: 0.5rem 0.8rem !important; */
    padding: 0.7rem !important;
}
.swal2-content {
    color: #000 !important;
    font-weight: 700 !important;
}
.logo{
  width: 60%;
}
/* .dark-layout .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, [dir] .main-menu.menu-light .navigation > li.sidebar-group-active > a {
    background-color: #161d31 !important;
} */

</style>
